module.exports = __webpack_public_path__ + "static/8-1400516e61683f67846fe88a2c019b51.jpg";